module.exports = __webpack_public_path__ + "static/media/advantages_bar_top.8f14bf72.svg";